import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X } from 'lucide-react';
const notifications = [{
  name: 'Gabriela F.',
  location: 'San Luis',
  product: 'Combo Diamante',
  time: 'hace 4 minutos'
}, {
  name: 'Martín R.',
  location: 'Córdoba',
  product: 'SuperPack 📘',
  time: 'hace 11 min'
}, {
  name: 'Valeria M.',
  location: 'Buenos Aires',
  product: 'Combo Diamante',
  time: 'hace 23 min'
}];
export function PurchaseNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before first notification
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      // Wait a bit before showing the next one
      const nextTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 5000);
      return () => clearTimeout(nextTimer);
    }
    // Hide after showing for a while
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 6000);
    return () => clearTimeout(hideTimer);
  }, [isVisible]);
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-195" data-mp="19perqy77eavc">
      <AnimatePresence data-id="element-196" data-mp="19o3nyydrd348">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        x: -50
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-brand-card border border-brand-green/30 rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.5)] p-4 pr-10 relative pointer-events-auto w-72" data-id="element-197" data-mp="1egn3i0w0a8bo">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" data-id="element-198" data-mp="2smjje91wuyfu">
              <X className="w-4 h-4" data-id="element-199" data-mp="2jopmox08i2s5" />
            </button>

            <div className="flex items-start gap-3" data-id="element-200" data-mp="3gdf4yofrwxen">
              <div className="bg-brand-green/20 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-201" data-mp="3gd5fd1yn4s9h">
                <Check className="w-4 h-4 text-brand-green" data-id="element-202" data-mp="3bfvrvrutaqoa" />
              </div>
              <div data-id="element-203" data-mp="37c7hz2ipjizv">
                <div className="text-xs text-brand-green font-bold uppercase tracking-wider mb-1" data-id="element-204" data-mp="37bny3g9hykj7">
                  Compra verificada
                </div>
                <div className="text-sm font-medium text-white" data-id="element-205" data-mp="1vxk9kploholj">
                  {current.name}{' '}
                  <span className="text-gray-400 font-normal" data-id="element-206" data-mp="1qy7ly2mzgdhw">
                    de {current.location}
                  </span>
                </div>
                <div className="text-sm text-gray-300 mt-0.5" data-id="element-207" data-mp="6ijb4bw7d6zh">
                  compró{' '}
                  <span className="font-bold text-white" data-id="element-208" data-mp="bgaycslwk4xc">
                    {current.product}
                  </span>
                </div>
                <div className="text-xs text-gray-500 mt-1" data-id="element-209" data-mp="k7utl4rbzwnk">{current.time}</div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}